<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row class="mb-2">
        <b-col>
          <router-link :to="{ name: 'EXCMDeviceModelList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col>
                <p><b>{{$t('views.excmdevice.show.type')}}</b> - {{item.idDeviceType.title}}</p>
                <p><b>{{$t('views.excmdevice.show.brand')}}</b> - {{item.idDeviceBrand.brandTitle}}</p>
                <p><b>{{$t('views.excmdevice.show.model')}}</b> - {{item.model}}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <hr>
                <h6>{{ $t('views.excmdevicemodel.show.devices') }}:</h6>
                <b-row v-for="(device, index) in item.devices" v-bind:key="'device-' + index">
                  <b-col>
                    <b-row v-if="index !== 0">
                      <b-col>
                        <hr class="mt-2 mb-2">
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <div class="float-left">
                          <h5>#{{index + 1}}</h5>
                        </div>
                        <div class="float-left ml-3">
                          <p class="m-0">
                            <b>{{$t('views.excmagreements.show.agreementDevice.serialNumber')}}:</b> {{ device.serialNumber }}
                          </p>
                          <p class="m-0">
                          <b>{{$t('views.excmdevice.show.localization')}}: </b>
                            <span v-if="device.city">{{device.city}}, </span>
                            <span v-if="device.street">{{device.street}} </span>
                            <span v-if="device.building">{{device.building}}</span>
                          </p>
                          <p class="m-0">
                            <router-link :to="{name: 'EXCMDeviceShow', params: { id: device['@id'] }}" class="btn btn-sm btn-success">
                              <span v-if="!mobileView">{{$t('buttons.goToDevice')}}</span>
                            </router-link>
                          </p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <hr>
                <h6>{{ $t('views.excmdevicemodel.show.documentFiles') }}:</h6>
                <b-row v-for="(documentFile, index) in item.documentFiles" v-bind:key="'documentFile-' + index">
                  <b-col>
                    <b-row v-if="index !== 0">
                      <b-col>
                        <hr class="mt-2 mb-2">
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <div class="float-left">
                          <h5>#{{index + 1}}</h5>
                        </div>
                        <div class="float-left ml-3">
                          <p class="m-0">
                            <b>{{ documentFile.fileName }}</b><br>
                          </p>
                          <b-row>
                            <b-col>
                              <b-button class="btn btn-success" size="sm" @click="downloadDocument(documentFile)">{{$t('buttons.downloadDocument')}}</b-button>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <hr>
                    <button type="button"
                            class="mb-1 mr-1 btn btn-info btn-circle btn-sm fa fa-plus fa-lg"
                            v-b-tooltip.hover :title="$t('buttons.uploadDocument')"
                            @click="uploadDocument()">
                    </button>
                    <span class="h6">{{$t('buttons.uploadDocument')}}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <UploadDocumentModal v-model="documentUploaded"></UploadDocumentModal>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import ApiService from '@/utils/ApiService'
import UploadDocumentModal from '@/components/Dashboard/Views/excmdevicemodel/components/UploadDocumentModal/UploadDocumentModal'
import getIdFromLink from '@/utils/getIdFromLink'

export default {
  components: {
    UploadDocumentModal,
    Loader
  },

  data () {
    return {
      view: null,
      deviceModelDevices: [],
      totalDeviceAgreementsNumber: 0,
      documentUploaded: 0
    }
  },
  computed: {
    ...mapGetters({
      deleteError: 'excmdevicemodel/del/error',
      error: 'excmdevicemodel/show/error',
      isLoading: 'excmdevicemodel/show/isLoading',
      item: 'excmdevicemodel/show/retrieved'
    }),
    mobileView () {
      return this.$store.state.mobileView
    }
  },
  watch: {
    documentUploaded: function () {
      if (this.documentUploaded === 1) {
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.documentUploaded = 0
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceModelShow')
  },

  methods: {
    ...mapActions({
      del: 'excmdevicemodel/del/del',
      reset: 'excmdevicemodel/show/reset',
      retrieve: 'excmdevicemodel/show/retrieve'
    }),
    downloadDocument (item) {
      new ApiService(item['@id'] + '/download').downloadFile(item.fileName)
    },
    uploadDocument () {
      this.$store.state.modals.uploadDocument.show = 1
      this.$store.state.modals.uploadDocument.path = 'api/e_x_c_m_device_models/' + getIdFromLink(this.item['@id']) + '/upload_document'
    },
    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMDeviceModelList' }))
      }
    }
  }
}
</script>
